// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"badb0cff","342":"c563fceb"}[chunkId] + ".chunk.css";
};